import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/use-auth";

export type Plan = "free" | "pro" | "premium";

const RANK: Record<Plan, number> = { free: 0, pro: 1, premium: 2 };

export function usePlan() {
  const { user } = useAuth();

  const { data, isLoading } = useQuery({
    queryKey: ["user-plan", user?.id],
    enabled: !!user,
    staleTime: 60_000,
    queryFn: async () => {
      if (!user) return "free" as Plan;
      const { data } = await supabase
        .from("profiles")
        .select("plan")
        .eq("user_id", user.id)
        .maybeSingle();
      const p = (data?.plan ?? "free").toLowerCase();
      if (p === "pro" || p === "premium") return p as Plan;
      // Premium Cortesia (admin-granted) acessa tudo como Premium
      if (p === "premium_courtesy") return "premium" as Plan;
      return "free" as Plan;
    },
  });

  const plan: Plan = data ?? "free";

  const has = (required: Plan) => RANK[plan] >= RANK[required];

  return { plan, isLoading, has };
}